/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Online_FullscreenInputs */

const en_pc_online_fullscreen = /** @type {(inputs: Pc_Online_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open full screen`)
};

const zh_pc_online_fullscreen = /** @type {(inputs: Pc_Online_FullscreenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全屏打开`)
};

/**
* | output |
* | --- |
* | "Open full screen" |
*
* @param {Pc_Online_FullscreenInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_online_fullscreen = /** @type {((inputs?: Pc_Online_FullscreenInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Online_FullscreenInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_online_fullscreen(inputs)
	return zh_pc_online_fullscreen(inputs)
});
export { pc_online_fullscreen as "pc.online.fullscreen" }